import rellenarPDF from "./rellenarPDF";
import { crearPoliza } from "../poliza/crearPoliza";
import mensajePreventivo from "../mensajes/mensajePreventivo";
import mensajeError from "../../helpers/mensajes/MensajeError";

import actualizarPorConcesion from "../contribuyente/historial/actualizarPorConcesion";
import actualizarSinConcesion from "../contribuyente/historial/actualizarSinConcesion";


export const generarPDF = async (data, setData, nuevosTramites, vigencia, aPagar, observaciones, anualidad, setNuevosTramites) => {

    if (data.contribuyente === undefined) {
        mensajePreventivo("Necesitas buscar un contribuyente.");
    }

    else if (nuevosTramites.length === 0) {
        mensajePreventivo("Necesitas añadir un concepto de pago.");
    }
    
    else if (data && nuevosTramites.length > 0) {
        crearPoliza(data, nuevosTramites[0], vigencia, observaciones, anualidad, aPagar)
            .then(dataPoliza => {
                const { idPolizaPago } = dataPoliza;
                for (let i = 0; i < nuevosTramites.length; i++) {
                    const dataPolizaConceptoFinal = {
                        idPolizaPago: idPolizaPago,
                        idConceptoPago: nuevosTramites[i].idConceptoPago,
                        idTramite: nuevosTramites[i].idTramite,
                        CRI: nuevosTramites[i].cri,
                        importe: nuevosTramites[i].pagoFinal,
                        ejercicioFiscal: nuevosTramites[i].ejercicio
                    }

                    const settings = {
                        method: "POST",
                        headers: {
                            "Accept": "application/json",
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(dataPolizaConceptoFinal)
                    };

                    fetch("/api/poliza/crear", settings)
                        .then(response => response.json())
                        .then(dataPolizaCrear => {
                            return new Promise((_, reject) => {
                                if (dataPolizaCrear.status !== "Ok") {
                                    reject("Ocurrió un error, intente de nuevo")
                                }
                            })
                        })
                        .catch(error => mensajeError(error.message));
                }
                fetch(`/api/historial/ObtenerOrdenPagoPorIdPoliza/${idPolizaPago}`)
                    .then(responsePoliza => responsePoliza.json())
                    .then(dataPoliza => {
                        if (dataPoliza.status === "Ok") {
                            return new Promise((_, reject) => {
                                if (dataPoliza.status === "Ok") {
                                    const { lineaCaptura } = dataPoliza.data;
                                    rellenarPDF(data, nuevosTramites, aPagar, vigencia, lineaCaptura, idPolizaPago, observaciones, anualidad);
                                    if (data.concesiones.length === 0 || !data.concesionActual?.idConcesion) actualizarSinConcesion(data, setData);
                                    else actualizarPorConcesion(data, setData);
                                    setNuevosTramites([]);
                                }
                                else {
                                    reject("Ocurrió un error, intente de nuevo (1)")
                                }
                            })
                        }
                        else throw new Error("Fue imposible obtener linea de captura");
                    })
                    .catch(error => mensajeError(error.message))
            })
            .catch(error => mensajeError(error.message));
    }
}